/* eslint-disable @typescript-eslint/no-explicit-any */
export const response = (
  res: any,
  extras: Record<string, any> = {},
): Record<string, any> => ({
  data: res.data,
  error: null,
  isError: false,
  ...extras,
});

export const errorResponse = (
  error: any,
  extras: Record<string, any> = {},
): Record<string, any> => ({
  data: null,
  error,
  isError: true,
  ...extras,
});
